import { clientsInstance } from "../axios";

export const getAllStores = async () => {
  let response = null;
  try {
    response = await clientsInstance.get("/stores");
  } catch (e) {}
  return response;
};
